import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Form } from "react-bootstrap";
import { I18n } from 'react-redux-i18n';
import QuillBox from "../QuillBox";
import { clearErrors } from "../../actions/errorActions";
import ButtonWithLoading from "../Buttons/ButtonWithLoading";
import GRecaptch from "../GRecaptch";
import { postMessage } from "../../redux/messages/actions/addActions";
import { CLEAR_SEND_MESSAGE_SUCCESS } from "../../redux/messages/actions/types";

export default function SendMessageModal(props){
    const dispatch = useDispatch();

    const {
        errorsId,
        errorsMsg,
        sendMessageSuccess,
      } = useSelector((state) => ({
        errorsId: state.error.id,
        errorsMsg: state.error.msg,
        sendMessageSuccess: state.messages.sendMessageSuccess,
    }));

    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState([]);
    const [localErrors, setLocalErrors] = useState({});
    const [isHuman, setIsHuman] = useState(false);

    const {
        modalTitle,
        morphType,
        morphID,
        userID,
        loading,
        setConfShow,
        setConfTitle,
        setConfMessage,
        setConfStatus,
        setDelay,
        onHide
    } = props;

    const handleHide = useCallback(() => {
        setLocalErrors({});
        onHide();
        dispatch(clearErrors());
    }, [dispatch, onHide]);

    const handleToast = useCallback((showToast, title, message, status, delay) => {
        setConfShow(showToast);
        setConfTitle(title);
        setConfMessage(message);
        setConfStatus(status);
        setDelay(delay);
    }, [setConfShow, setConfTitle, setConfMessage, setConfStatus, setDelay]);

    useEffect(() => {
        if (Object.keys(errorsMsg).length > 0){
          setErrors(errorsMsg.errors);
        };
    }, [errorsMsg]);

    useEffect(() => {
        if (sendMessageSuccess){
            handleHide();
            handleToast(true, I18n.t('sending_message'), I18n.t('message_sent__success'), 'Toast__Container__Success', 6000);
            dispatch({
                type: CLEAR_SEND_MESSAGE_SUCCESS
            });
            setMessage("");
            setErrors([]);
            setLocalErrors({});
            setIsHuman(false);
        };
    }, [sendMessageSuccess, dispatch, handleHide, handleToast]);

    function isObject(val) {
        return (typeof val === 'object');
    }

    function handleItemLocalError({ propName, currentValue, message, uploadArray }) {
        if(currentValue){
            if(isObject(currentValue) && !Array.isArray(currentValue)){
                if (Object.keys(currentValue).length > 0) {
                    setLocalErrors((errors) => ({
                    ...errors,
                    [propName]: undefined,
                    }));
                } else {
                    setLocalErrors((errors) => ({
                    ...errors,
                    [propName]: message,
                    }));
                }
            }else if(Array.isArray(currentValue) && uploadArray === false){
                if (currentValue.length <= 0) {
                    setLocalErrors((errors) => ({
                    ...errors,
                    [propName]: message,
                    }));
                }else{
                    setLocalErrors((errors) => ({
                    ...errors,
                    [propName]: undefined,
                    }));
                }
            }else{
                setLocalErrors((errors) => ({
                    ...errors,
                    [propName]: undefined,
                }));
            }
        }else{
            setLocalErrors((errors) => ({
            ...errors,
            [propName]: message,
            }));
        }
    }

    function handleMessageChange(value) {
        value = value || "";
        if (value.replace(/<(.|\n)*?>/g, "").trim().length === 0) {
            setMessage("");
        } else {
            setMessage(value);
        }
    }

    function onMessageBlur(){
        handleItemLocalError({
            propName: "message",
            currentValue: message,
            message: I18n.t('description_required'),
        });
    }

    function onSubmit(e) {
        e.preventDefault();

        handleItemLocalError({
            propName: "message",
            currentValue: message,
            message: I18n.t('description_required'),
        });

        const to = userID;
        if(
            message !== "" &&
            isHuman
            ){
            dispatch(postMessage(
                message,
                to,
                morphType,
                morphID,
            ));
        } else{
            handleToast(true, I18n.t('complete_required_info_title'), I18n.t('complete_required_info'), 'Toast__Container__Warning', 6000)
        }
    };

    return(
        <Modal
            className={props.className}
            size={props.size}
            show={props.show}
            onHide={props.onHide}
            backdrop={props.backdrop}
            keyboard={props.keyboard}
            aria-labelledby={props["aria-labelledby"]}
            >
            <Form>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modalTitle}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <QuillBox
                        required
                        controlId="Description"
                        label="message"
                        value={message}
                        onChange={handleMessageChange}
                        onBlur={onMessageBlur}
                        feedbackType="invalid"
                        feedback={localErrors.message ? localErrors.message : null}
                        isInvalid={(errorsId === "SEND_MESSAGE_FAIL" && errors.message) || localErrors.message}
                    />

                    <GRecaptch
                        setIsHuman={setIsHuman}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <ButtonWithLoading
                        variant="primary"
                        type="submit"
                        onClick={onSubmit}
                        data-backdrop="static"
                        loading={loading ? loading : null}
                    >
                        {I18n.t('submit')}
                    </ButtonWithLoading>
                    <Button
                        variant="secondary"
                        className="btn btn-secondary"
                        onClick={handleHide}
                    >
                        {I18n.t('close')}
                    </Button>
                </Modal.Footer>
            </Form>
            </Modal>
    )
}